var componentRequireContext = require.context("components", true, /front\/staff|youtube\/*/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);